// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3wf8h","header":"MergedInvoice_header__24-PX"};